import { render, staticRenderFns } from "./beside-image.vue?vue&type=template&id=de52a61a"
import script from "./beside-image.vue?vue&type=script&lang=js"
export * from "./beside-image.vue?vue&type=script&lang=js"
import style0 from "./beside-image.vue?vue&type=style&index=0&id=de52a61a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports